import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eadb6924"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rule-title" }, "Selectati regula de decontare automata:", -1))
const _hoisted_3 = { class: "field-group-left" }
const _hoisted_4 = { class: "flex align-items-baseline gap-1" }
const _hoisted_5 = { class: "field-group-left" }
const _hoisted_6 = { class: "flex align-items-baseline gap-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border":"1px solid #f6f6f6","margin":"20px 0px"} }, null, -1))
const _hoisted_8 = { class: "field-group-left" }
const _hoisted_9 = { class: "flex align-items-baseline gap-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rule-title" }, "Introduceti comisionul aplicat medicului:", -1))

import {
  ref,
  onMounted,
  PropType,
  watch,
  computed
} from 'vue';

import { Doctor } from '@/interfaces/Doctor';
import InputNumber from 'primevue/inputnumber';
import PayoutService from '@/services/PayoutService';


export default /*#__PURE__*/_defineComponent({
  __name: 'PayoutInfo',
  props: {
  modelValue: {
    type: Object as PropType<Doctor>,
    default: () => ({})
  }
},
  emits: ['update:payoutFormValidationChangeState'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const thisDoctor = ref<Doctor>(props.modelValue || ({} as Doctor));
const amountTrigger = ref(0);
const timeTrigger = ref(30);
const commissionPercent = ref(0.5);

const isValidForm = computed(() => {
  return (
    (amountTrigger.value > 0 || timeTrigger.value > 0) &&
    amountTrigger.value !== timeTrigger.value
  );
});

watch(commissionPercent, (newValue) => {
  if (!thisDoctor.value.config) {
    thisDoctor.value.config = {
      patientsPerHour: 0,
      charactersLimit: 0,
      consultationPrice: 0,
      payoutDaysInterval: 0,
      payoutMoneyLimit: 0,
      commissionPercent: 0
    };
  }
  if (newValue > 0) {
    thisDoctor.value.config.commissionPercent = newValue / 100;
  }
});

watch(amountTrigger, (newValue) => {
  if (!thisDoctor.value.config) {
    thisDoctor.value.config = {
      patientsPerHour: 0,
      charactersLimit: 0,
      consultationPrice: 0,
      payoutDaysInterval: 0,
      payoutMoneyLimit: 0,
      commissionPercent: 0
    };
  }
  if (newValue > 0) {
    thisDoctor.value.config.payoutMoneyLimit = newValue * 100;
    thisDoctor.value.config.payoutDaysInterval = 0;
    timeTrigger.value = 0;
  } else {
    thisDoctor.value.config.payoutMoneyLimit = 0;
  }
});

watch(timeTrigger, (newValue) => {
  if (!thisDoctor.value.config) {
    thisDoctor.value.config = {
      patientsPerHour: 0,
      charactersLimit: 0,
      consultationPrice: 0,
      payoutDaysInterval: 0,
      payoutMoneyLimit: 0,
      commissionPercent: 0
    };
  }
  if (newValue > 0) {
    thisDoctor.value.config.payoutDaysInterval = newValue;
    thisDoctor.value.config.payoutMoneyLimit = 0;
    amountTrigger.value = 0;
  } else {
    thisDoctor.value.config.payoutDaysInterval = 0;
  }
});

watch(isValidForm, (newValue) => {
  emit('update:payoutFormValidationChangeState', newValue);
});

setTimeout(() => {
  emit('update:payoutFormValidationChangeState', isValidForm);
}, 1);

onMounted(async () => {
  commissionPercent.value =
    (await PayoutService.fetchDefaultCommission()) * 100;
  if (!thisDoctor.value.config) {
    thisDoctor.value.config = {
      patientsPerHour: 0,
      charactersLimit: 0,
      consultationPrice: 0,
      payoutDaysInterval: 7,
      payoutMoneyLimit: 0,
      commissionPercent: 0
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(" La interval de: "),
        _createVNode(_unref(InputNumber), {
          max: 30,
          id: "timeTrigger",
          modelValue: timeTrigger.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((timeTrigger).value = $event)),
          class: "w-1",
          disabled: true,
          suffix: " zile",
          inputStyle: {
            width: '70px !important',
            height: '5px !important'
          }
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(" La atingerea venitului din consultatii: "),
        _createVNode(_unref(InputNumber), {
          id: "amountTrigger",
          modelValue: amountTrigger.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((amountTrigger).value = $event)),
          disabled: true,
          suffix: " lei",
          inputStyle: {
            width: '70px !important',
            height: '5px !important'
          }
        }, null, 8, ["modelValue"])
      ])
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_unref(InputNumber), {
          min: 0,
          max: 100,
          id: "commissionPercent",
          mode: "decimal",
          inputStyle: {
            width: '80px !important',
            height: '5px !important'
          },
          suffix: " %",
          minFractionDigits: 2,
          maxFractionDigits: 2,
          modelValue: commissionPercent.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((commissionPercent).value = $event))
        }, null, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})